import styled from 'styled-components';

export const NakedButton = styled.button`
  appearance: none;
  background: unset;
  border: none;
  color: inherit;
  display: inline-block;
  font: inherit;
  padding: initial;
  cursor: pointer;
`;
